module.exports = __webpack_public_path__ + "static/bg-1.1-2fef483936acc64e1663d9d636356bca.png";